// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__AZWxm","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1gzXb"};